<template>
    <div class="open-hours-services">
        <div class="services">
            <div
                v-for="(item, key) in computedServices"
                :key="`item-${key}`"
                class="service-item"
            >
                <DSFontIcon
                    v-if="item.icon.code"
                    :code="item.icon.code"
                    :icon-style="item.icon.style"
                    size="l"
                />
                <span>{{ $t(`stationAttributes.${item.title}`) }}</span>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, useI18n } from '#imports';
import { storeToRefs } from 'pinia';
import { usePageStore } from '~dsc/stores/cms/page';
const { locale } = useI18n();
const { station } = storeToRefs(usePageStore());

const computedServices = computed(() => {
    const icons = {
        servicefueling: { icon: 'servicedfueling', iconStyle: 'filled' },
        adblueprivatecars: { icon: 'adblue', iconStyle: 'filled' },
        carmaintenance: { icon: 'vehiclemaintenance', iconStyle: 'filled' },
        trailerrent: { icon: 'trailer', iconStyle: 'filled' },
        post: { icon: 'package', iconStyle: 'filled' },
        matkahuolto: { icon: 'package', iconStyle: 'filled' },
        sauna: { icon: 'sauna', iconStyle: 'filled' },
        shower: { icon: 'shower', iconStyle: 'filled' },
        truckfuelingpoint: { icon: 'truck', iconStyle: 'filled' },
        selfservicecarwash: { icon: 'carwashselfservice', iconStyle: 'filled' },
        carwash: { icon: 'carwash', iconStyle: 'filled' },
        perfectcarwash: { icon: 'carwash', iconStyle: 'filled' },
        carwash24h: { icon: 'carwash', iconStyle: 'filled' },
        perfectcarwash24hours: { icon: 'carwash', iconStyle: 'filled' },
        selfservicepaymentterminal: { icon: 'paymentcards', iconStyle: 'filled' },
        burgerking: { icon: 'hamburger', iconStyle: 'filled' },
        kotipizza: { icon: 'pizza', iconStyle: 'filled' },
        lunch: { icon: 'restaurantstations', iconStyle: 'filled' },
        weekendlunch: { icon: 'restaurantstations', iconStyle: 'filled' },
        cafeteria: { icon: 'cafe', iconStyle: 'line' },
        driverspremium: { icon: 'hamburger', iconStyle: 'filled' },
        goldenrax: { icon: 'pizza', iconStyle: 'filled' },
        othershop: { icon: 'services', iconStyle: 'filled' },
        restaurantnotconcept: { icon: 'restaurantstations', iconStyle: 'filled' },
        meetingroom: { icon: 'whiteboard', iconStyle: 'filled' },
        drivers: { icon: 'hamburger', iconStyle: 'filled' },
        freewifi: { icon: 'network', iconStyle: 'filled' },
        pizza: { icon: 'pizza', iconStyle: 'filled' },
        truck: { icon: 'truck', iconStyle: 'filled' },
        food: { icon: 'restaurantstations', iconStyle: 'filled' },
        coffee: { icon: 'cafe', iconStyle: 'line' },
        boutique: { icon: 'cart', iconStyle: 'filled' },
        fueling: { icon: 'refuel', iconStyle: 'filled' },
        laddstation: { icon: 'recharge', iconStyle: 'filled' },
        toilet: { icon: 'toilet', iconStyle: 'filled' },
        wifi: { icon: 'network', iconStyle: 'filled' },
        bottledgas: { icon: 'bottledgas', iconStyle: 'filled' },
        accessibletoilet: { icon: 'disabilitytoilet', iconStyle: 'filled' },
        changingtable: { icon: 'familyroom', iconStyle: 'filled' },
        devicecharging: { icon: 'batterycharge', iconStyle: 'filled' },
        seatingarea: { icon: 'outdoorseat', iconStyle: 'filled' },
        schenker: { icon: 'package', iconStyle: 'filled' },
        budbee: { icon: 'package', iconStyle: 'filled' },
    };

    const brandServices = ['welcomein', 'ploq', 'dirtcarwash'];
    const notBrandService = service => !brandServices.includes(service.title);
    const extraLocaleFilter = service => {
        if (locale.value === 'sv-SE') return !['coffee', 'othershop', 'butik-ploq', 'butik-welcomein'].includes(service.title);

        return true;
    };
    const serviceCodeToServiceObject = service => {
        const serviceName = service.replace(/^finland\//, '').replace(/^sweden\//, '').replace(/^norway\//, '');

        return {
            icon: {
                code: icons?.serviceName?.icon ?? 'services',
                style: icons?.serviceName?.iconStyle ?? 'filled',
            },
            title: serviceName,
        };
    };

    return Array.from(new Set(station.value.services) ?? [])
        .map(serviceCodeToServiceObject)
        .filter(notBrandService)
        .filter(extraLocaleFilter);
});
</script>
<script>
export default {
    name: 'StationsFunctionsServices',
};
</script>
<style scoped>
.open-hours-services {
  max-width: 680px;
  margin-bottom: 2rem;
}
.open-hours-services .open-hours-item .row {
  display: flex;
  justify-content: space-between;
}
.open-hours-services .open-hours-item .row:not(:last-child) {
  margin-bottom: 0.5rem;
}
.open-hours-services .open-hours-item:not(:last-child) {
  margin-bottom: 1.5rem;
}
.open-hours-services .service-item {
  display: grid;
  align-content: center;
  grid-template-columns: 2rem auto;
  min-height: 2.5rem;
  padding: 0.25rem;
}
.open-hours-services .service-item .icon {
  display: inline-flex;
  align-items: center;
  color: var(--color-base-grey-800);
}
@media (min-width: 768px) {
  .open-hours-services .services {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 1rem;
    box-sizing: border-box;
  }
  .open-hours-services .services > :nth-child(odd) {
    border-right: 1px solid var(--color-base-grey-300);
    margin-right: 2rem;
    padding-right: 2rem;
  }
}
</style>
